import React from "react";

import type { Excluded } from "@/api/warehouse_ops";
import { cn } from "@/lib/utils";
import { excludedLines } from "@/lib/warehouse-ops";

/** Не посчитано: сессии в другой базе 1С (реплика) — числом и с причиной, а не
 *  молча (решение владельца «B»). Своя база не известна — предупреждение. */
export function ExcludedBlock({ excluded }: { excluded: Excluded }): React.ReactElement | null {
  const lines = excludedLines(excluded);
  if (lines.length === 0) return null;
  return (
    <section
      aria-label="Не посчитано"
      role={excluded.known ? undefined : "status"}
      className={cn(
        "space-y-0.5 rounded-lg border p-3 text-xs",
        excluded.known ? "bg-white text-muted-foreground" : "border-amber-300 bg-amber-50 text-amber-900",
      )}
    >
      {lines.map((l) => (
        <div key={l}>{l}</div>
      ))}
    </section>
  );
}
